import { useTranslation } from 'react-i18next'
import { FieldProps } from './constants'
import { Select, SelectItem } from '@calabriocloud/beacon-ui'
import { useQuery } from 'react-query'
import axios from 'axios'


const getSystemChannelEndpoint = '/api/rest/recording/metadataValues?metadataFieldKey=system-channel'
export const ChannelField = ({ classifier, field, onChange }: FieldProps) => {
  const { t } = useTranslation()
  const baseValue = { classifierType: classifier.id, fieldKey: null }
  const { data: channels } = useQuery({
    queryKey: ['channels'],
    queryFn: async () => {
      const res = await axios.get<string[]>(getSystemChannelEndpoint)
      return res.data
    },
  })
  const handleChange = (key: number) => {
    const selectedItem = channels?.[key]
    if (selectedItem) {
      onChange({
        ...baseValue,
        field: selectedItem,
        name: `${t(classifier.name)}: ${t(selectedItem)}`,
      })
    }
  }

  return (
    <div className='flex flex-row gap-4 pb-4'>
      <Select
        label={t(classifier.name)}
        className='w-80'
        name='channelFieldId'
        data-testid='classifier-channel-select'
        onSelectionChange={handleChange}
        selectedKey={field?.field ? channels?.indexOf(field.field) : undefined}
        items={channels?.map((value, index) => ({ id: index, name: value })) || []}>
        {item => (<SelectItem key={item.id} id={item.id}>{t(item.name)}</SelectItem>)}
      </Select>
    </div>
  )
}
